export const LOGIN_TOKEN_KEY = 'LOGIN_TOKEN';

export const RQ_QUERY_MYSELF = 'myself';
